import styled from "@emotion/styled";
import { ScrollShadowContainer } from "@ui-kit/ScrollShadowContainer";

const PropertiesScrollContainer = styled(ScrollShadowContainer)`
	max-height: max(45dvh, 30rem);
	max-width: 15rem;
	overflow-x: hidden;
`;

export default PropertiesScrollContainer;
